import { Group } from '@mantine/core';

import Chevrons from '@/assets/icons/sidebar/chevrons.svg';

import navBarClasses from './Navbar.module.css';

interface ExpandProps {
  toggleDesktop: () => void;
  desktopOpened: boolean;
}

const Expand = ({ toggleDesktop, desktopOpened }: ExpandProps) => (
  <Group
    align="center"
    wrap="nowrap"
    gap="var(--ds-space-8)"
    aria-label={desktopOpened ? 'Collapse' : 'Expand'}
    classNames={{
      root: `${navBarClasses.footerNavRow} ${navBarClasses.expandClickable}`,
    }}
    onClick={toggleDesktop}
  >
    <span
      className={`${navBarClasses.footerNavIcon} ${desktopOpened ? navBarClasses.footerNavIconExpanded : ''}`}
    >
      <Chevrons />
    </span>

    <span className={navBarClasses.toggleLabel}>{desktopOpened ? 'Collapse' : 'Expand'}</span>
  </Group>
);

export default Expand;
